import Vue from 'vue'

// Import Application stylesheet
import '@/assets/styles/app.styl'

import {
  Vuetify,
  VApp,
  VAlert,
  VAvatar,
  VBtn,
  VBtnToggle,
  VCard,
  VCheckbox,
  VChip,
  VCombobox,
  VDataTable,
  VDialog,
  VDivider,
  VExpansionPanel,
  VFooter,
  VForm,
  VGrid,
  VJumbotron,
  VIcon,
  VList,
  VNavigationDrawer,
  VPagination,
  VProgressCircular,
  VProgressLinear,
  VRadioGroup,
  VSelect,
  VSubheader,
  VTextField,
  VToolbar,
  VTooltip,
  transitions
} from 'vuetify'

import { Resize, Ripple } from 'vuetify/es5/directives'

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VAvatar,
    VBtn,
    VBtnToggle,
    VCard,
    VCheckbox,
    VChip,
    VCombobox,
    VDataTable,
    VDialog,
    VDivider,
    VExpansionPanel,
    VFooter,
    VForm,
    VGrid,
    VIcon,
    VJumbotron,
    VList,
    VNavigationDrawer,
    VPagination,
    VProgressCircular,
    VProgressLinear,
    VRadioGroup,
    VSelect,
    VSubheader,
    VTextField,
    VToolbar,
    VTooltip,
    transitions
  },
  directives: {
    Resize,
    Ripple
  },
  theme: {}
})



// WEBPACK FOOTER //
// ./frontend/src/plugins/vuetify.js